import React from "react";

const formatMoney = (value) => Number(value || 0).toFixed(2);

export function QuotationPrintView({
  quotation,
  companyInfo,
  clientName,
  statusLabel,
}) {
  if (!quotation) return null;

  const sectionStyle = {
    pageBreakInside: "avoid",
    breakInside: "avoid",
  };

  return (
    <div
      style={{
        width: "794px",
        minHeight: "1123px",
        backgroundColor: "#ffffff",
        color: "#0B0E14",
        fontFamily: "Arial, Helvetica, sans-serif",
        padding: "40px",
        boxSizing: "border-box",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            borderBottom: "3px solid #E2B05E",
            paddingBottom: "16px",
            gap: "24px",
            ...sectionStyle,
          }}
        >
          <div style={{ display: "flex", alignItems: "flex-start", gap: "16px", minWidth: 0 }}>
            {companyInfo?.logo_url ? (
              <img
                src={companyInfo.logo_url}
                alt="Logo"
                crossOrigin="anonymous"
                style={{ height: "64px", width: "auto", objectFit: "contain", flexShrink: 0 }}
              />
            ) : null}

            <div style={{ minWidth: 0 }}>
              <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 700, lineHeight: 1.2 }}>
                {companyInfo?.name || "Valhalla Corporations S.E.P."}
              </h2>
              <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#4B5563" }}>
                RUC: {companyInfo?.ruc || "-"}
              </p>
              <p style={{ margin: "4px 0 0", fontSize: "11px", color: "#6B7280" }}>
                {companyInfo?.address || ""}
              </p>
              <p style={{ margin: "4px 0 0", fontSize: "11px", color: "#6B7280" }}>
                {(companyInfo?.phone || "-") + " | " + (companyInfo?.email || "-")}
              </p>
            </div>
          </div>

          <div style={{ textAlign: "right", flexShrink: 0 }}>
            <h3
              style={{
                margin: 0,
                fontSize: "28px",
                fontWeight: 800,
                color: "#E2B05E",
                lineHeight: 1.1,
                fontFamily: "Outfit, Arial, Helvetica, sans-serif",
              }}
            >
              Cotización
            </h3>
            <p style={{ margin: "8px 0 0", fontSize: "16px", fontWeight: 700 }}>
              {quotation.quotation_number}
            </p>
            <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#4B5563" }}>
              Fecha: {quotation.issue_date || "-"}
            </p>
            <div
              style={{
                display: "inline-block",
                marginTop: "10px",
                padding: "6px 10px",
                borderRadius: "999px",
                fontSize: "11px",
                fontWeight: 700,
                border: "1px solid rgba(0,0,0,0.08)",
                backgroundColor:
                  quotation.status === "aceptada"
                    ? "#d1fae5"
                    : quotation.status === "rechazada"
                      ? "#fee2e2"
                      : quotation.status === "enviada"
                        ? "#dbeafe"
                        : quotation.status === "vencida"
                          ? "#fef3c7"
                          : quotation.status === "facturada"
                            ? "#ede9fe"
                            : "#f3f4f6",
                color:
                  quotation.status === "aceptada"
                    ? "#047857"
                    : quotation.status === "rechazada"
                      ? "#b91c1c"
                      : quotation.status === "enviada"
                        ? "#1d4ed8"
                        : quotation.status === "vencida"
                          ? "#b45309"
                          : quotation.status === "facturada"
                            ? "#7c3aed"
                            : "#6b7280",
              }}
            >
              {statusLabel || quotation.status}
            </div>
          </div>
        </div>

        <div
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #E5E7EB",
            borderRadius: "12px",
            padding: "16px",
            ...sectionStyle,
          }}
        >
          <h4 style={{ margin: "0 0 10px", fontSize: "14px", fontWeight: 700 }}>Cliente</h4>
          <p style={{ margin: 0, fontSize: "14px", fontWeight: 600 }}>{clientName || "-"}</p>
          {quotation.client?.contact_name ? (
            <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#4B5563" }}>
              Attn: {quotation.client.contact_name}
            </p>
          ) : null}
          {quotation.client?.tax_id ? (
            <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#4B5563" }}>
              RUC: {quotation.client.tax_id}
            </p>
          ) : null}
          {quotation.client?.address ? (
            <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#4B5563" }}>
              {quotation.client.address}
            </p>
          ) : null}
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed", ...sectionStyle }}>
          <thead>
            <tr style={{ backgroundColor: "#F3F4F6", color: "#0B0E14", borderBottom: "2px solid #E2B05E" }}>
              <th style={{ padding: "12px", textAlign: "left", fontSize: "12px", fontWeight: 700, width: "52%" }}>Descripción</th>
              <th style={{ padding: "12px", textAlign: "center", fontSize: "12px", fontWeight: 700, width: "12%" }}>Cant.</th>
              <th style={{ padding: "12px", textAlign: "right", fontSize: "12px", fontWeight: 700, width: "18%" }}>Precio U.</th>
              <th style={{ padding: "12px", textAlign: "right", fontSize: "12px", fontWeight: 700, width: "18%" }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {(quotation.items || []).map((item, i) => (
              <tr key={i} style={{ borderBottom: "1px solid #E5E7EB" }}>
                <td style={{ padding: "12px", fontSize: "12px", verticalAlign: "top" }}>{item.description || "-"}</td>
                <td style={{ padding: "12px", fontSize: "12px", textAlign: "center", verticalAlign: "top" }}>{item.quantity ?? 0}</td>
                <td style={{ padding: "12px", fontSize: "12px", textAlign: "right", verticalAlign: "top" }}>${formatMoney(item.unit_price)}</td>
                <td style={{ padding: "12px", fontSize: "12px", textAlign: "right", verticalAlign: "top" }}>${formatMoney(item.total)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ display: "flex", justifyContent: "flex-end", ...sectionStyle }}>
          <div style={{ width: "280px", border: "1px solid #E5E7EB", borderRadius: "12px", padding: "16px", backgroundColor: "#fff" }}>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", marginBottom: "8px" }}>
              <span style={{ color: "#4B5563" }}>Subtotal</span>
              <span>${formatMoney(quotation.subtotal)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", marginBottom: "8px" }}>
              <span style={{ color: "#4B5563" }}>ITBMS ({quotation.itbms_rate || 0}%)</span>
              <span>${formatMoney(quotation.itbms_amount)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", paddingTop: "10px", borderTop: "2px solid #0B0E14", fontSize: "16px", fontWeight: 800 }}>
              <span>Total</span>
              <span style={{ color: "#E2B05E" }}>${formatMoney(quotation.total)}</span>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
            backgroundColor: "#F9FAFB",
            border: "1px solid #E5E7EB",
            borderRadius: "12px",
            padding: "16px",
            fontSize: "12px",
            ...sectionStyle,
          }}
        >
          <div>
            <p style={{ margin: 0, fontWeight: 700 }}>Vigencia</p>
            <p style={{ margin: "4px 0 0", color: "#4B5563" }}>{quotation.expiry_date || "-"}</p>
          </div>
          <div>
            <p style={{ margin: 0, fontWeight: 700 }}>Condiciones de pago</p>
            <p style={{ margin: "4px 0 0", color: "#4B5563" }}>{quotation.payment_terms || "-"}</p>
          </div>
          {quotation.delivery_time ? (
            <div>
              <p style={{ margin: 0, fontWeight: 700 }}>Tiempo de entrega</p>
              <p style={{ margin: "4px 0 0", color: "#4B5563" }}>{quotation.delivery_time}</p>
            </div>
          ) : null}
          {quotation.warranty ? (
            <div>
              <p style={{ margin: 0, fontWeight: 700 }}>Garantía</p>
              <p style={{ margin: "4px 0 0", color: "#4B5563" }}>{quotation.warranty}</p>
            </div>
          ) : null}
        </div>

        {quotation.notes ? (
          <div style={{ fontSize: "12px", ...sectionStyle }}>
            <p style={{ margin: "0 0 6px", fontWeight: 700 }}>Observaciones</p>
            <p style={{ margin: 0, color: "#4B5563", whiteSpace: "pre-wrap" }}>{quotation.notes}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default QuotationPrintView;
